import Vue from 'vue'
import Router from 'vue-router'
import Home from '../components/Home'
import About from '../components/About'
import News from '../components/News'
import Contact from '../components/Contact'
import Join from '../components/Join'
import Institution from '../components/case/Institution'
import Core from '../components/case/Core'
import Chain from '../components/case/Chain'
import Product from '../components/products/Product'
import Platform from '../components/products/Platform'
import Service from '../components/products/Service'
import Download from '../components/Download'
import openLogin from '../components/OpenLogin'

Vue.use(Router)

function $ (subTitle) {
  return '群星金融' + ' - ' + subTitle
}

const ROUTER = new Router({
  routes: [
    {
      path: '/',
      component: Home,
      meta: {
        title: $('首页')
      }
    },
    {
      path: '/institution',
      component: Institution,
      meta: {
        title: $('角色解决方案')
      }
    },
    {
      path: '/core',
      component: Core,
      meta: {
        title: $('角色解决方案')
      }
    },
    {
      path: '/chain',
      component: Chain,
      meta: {
        title: $('角色解决方案')
      }
    },
    {
      path: '/service',
      component: Service,
      meta: {
        title: $('供应链金融服务')
      }
    },
    {
      path: '/product',
      component: Product,
      meta: {
        title: $('平台产品')
      }
    },
    {
      path: '/platform',
      component: Platform,
      meta: {
        title: $('平台产品')
      }
    },
    {
      path: '/about',
      component: About,
      meta: {
        title: $('关于群星')
      }
    },
    {
      path: '/news',
      component: News,
      meta: {
        title: $('企业动态')
      }
    },
    {
      path: '/contact',
      component: Contact,
      meta: {
        title: $('联系我们')
      }
    },
    {
      path: '/join',
      component: Join,
      meta: {
        title: $('加入我们')
      }
    },
    {
      path: '/download',
      component: Download,
      meta: {
        title: $('下载方案')
      }
    },
    {
      path: '/openLogin/:logo',
      component: openLogin,
      meta: {
        title: '登录'
      }
    }
  ]
})

ROUTER.beforeEach((to, from, next) => {
  document.title = to.meta.title
  next()
})

export default ROUTER



// WEBPACK FOOTER //
// ./src/components/portal/js/Router.js